import { addStyles, DefaultTheme } from '../theme';
import { ColorPalette2022Branding } from '../theme.palette';

export const CSS = {
	alertHref: 'c-Page__alert-href',
	closeButton: 'c-Page__CloseButton',
	alert: 'c-Page__alert',
	closeIcon: 'c-Page__CloseIcon',
	message: 'c-Page__message',
};

const alertHeightDesktop = 36;
const alertHeightLaptop = 60;
const alertHeightMobile = 84;

const Style = {
	[CSS.closeButton]: {
		position: 'absolute',
		right: DefaultTheme.space(1),
		color: ColorPalette2022Branding.darkGray,
		background: 'none',
		padding: DefaultTheme.space(1.5),
		border: `1px solid ${ColorPalette2022Branding.darkGray}`,
		borderRadius: '2px',
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
		transition: 'all 0.15s ease',

		['&:hover']: {
			color: ColorPalette2022Branding.g11,
			borderColor: ColorPalette2022Branding.g11,
		},
	},
	[CSS.alertHref]: {
		textDecoration: 'underline',
		color: ColorPalette2022Branding.lightIndigo,

		['&:hover']: {
			color: ColorPalette2022Branding.lightGray,
		},
	},
	[CSS.alert]: {
		height: `${alertHeightDesktop}px`,
		backgroundColor: ColorPalette2022Branding.ikeOrange,
		color: ColorPalette2022Branding.darkGray,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		boxSizing: 'border-box',
		padding: '0 12px',
		['@media only screen and (max-width: 1200px)']: {
			height: `${alertHeightLaptop}px`,
		},
		['@media only screen and (max-width: 700px)']: {
			height: `${alertHeightMobile}px`,
		},
	},
	[`${CSS.alert} a`]: {
		transition: 'color 0.15s ease',
	},
	[CSS.closeIcon]: {
		fontSize: '16px',
	},
	[CSS.message]: {
		'padding-right': '70px',
	},
};

addStyles(Style);
